"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const modal_style_1 = __importDefault(require("./modal.style"));
const modal_header_1 = __importDefault(require("./modal.header"));
const veneer_1 = __importDefault(require("../veneer/veneer"));
// used when click outside disabled
const voidFn = () => { };
class Modal extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('modal_');
        this.render = () => {
            const { classes, title, children, handleCollapse, focusElement, closeButtonLabel, large, fullscreen, hideCloseButton, hideHeaderBorderBottom, disableClickOutside } = this.props;
            const titleId = `${this.id}_title`;
            const veneerProps = {
                handleCollapse: disableClickOutside ? voidFn : handleCollapse,
                focusElement
            };
            const rootProps = {
                className: classes.root,
                role: 'dialog',
                'aria-labelledby': titleId,
                'data-is-large': large,
                'data-is-fullscreen': fullscreen
            };
            const headerProps = {
                titleId,
                title,
                closeButtonLabel,
                handleClose: handleCollapse,
                hideCloseButton,
                hideHeaderBorderBottom
            };
            return (jsx_runtime_1.jsx(veneer_1.default, Object.assign({}, veneerProps, { children: jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(modal_header_1.default, Object.assign({}, headerProps), void 0), children] }), void 0) }), void 0));
        };
    }
}
exports.Modal = Modal;
Modal.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    title: prop_types_1.default.node.isRequired,
    children: prop_types_1.default.node.isRequired,
    handleCollapse: prop_types_1.default.func.isRequired,
    focusElement: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
        prop_types_1.default.func
    ]),
    closeButtonLabel: prop_types_1.default.string,
    large: prop_types_1.default.bool,
    fullscreen: prop_types_1.default.bool,
    hideCloseButton: prop_types_1.default.bool,
    hideHeaderBorderBottom: prop_types_1.default.bool,
    disableClickOutside: prop_types_1.default.bool
};
Modal.defaultProps = {
    focusElement: null,
    closeButtonLabel: 'Close',
    large: false,
    fullscreen: false,
    hideCloseButton: false,
    hideHeaderBorderBottom: false,
    disableClickOutside: false
};
exports.default = react_jss_1.default(modal_style_1.default)(Modal);
//# sourceMappingURL=modal.js.map